<template>
  <landing-page-order-configuration-extension-modspace
    v-if="extension.extensionKey === 'ModsSpace'"
    :extension="extension"
  />
</template>

<script setup lang="ts">
import type { StrapiOrderConfigurationExtension } from '#variant/apollo/types/types';

defineProps<{
  extension: StrapiOrderConfigurationExtension;
}>();
</script>
